export default function Services() {
  const services = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'AI Education & Training',
      description: 'Comprehensive 6-12 month foundational programs designed to take your team from zero AI knowledge to confident users.',
      features: ['Beginner-friendly curriculum', 'Hands-on learning', 'Real-world applications', 'Progress tracking']
    },
    {
      icon: 'ri-tools-line',
      title: 'Custom AI Tools',
      description: 'Tailored AI solutions built specifically for your business needs, workflows, and industry requirements.',
      features: ['Workflow automation', 'Custom integrations', 'Scalable solutions', 'User-friendly interfaces']
    },
    {
      icon: 'ri-team-line',
      title: 'Workshops & Coaching',
      description: 'Interactive workshops and one-on-one coaching sessions to help your team master AI tools and strategies.',
      features: ['Group workshops', 'Individual coaching', 'Practical exercises', 'Q&A sessions']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Ongoing Support',
      description: 'Continuous guidance and support to ensure your AI implementation stays effective and up-to-date.',
      features: ['24/7 assistance', 'Regular check-ins', 'Updates & maintenance', 'Strategy refinement']
    },
    {
      icon: 'ri-flow-chart',
      title: 'AI Workflow Design',
      description: 'Strategic planning and implementation of AI-powered workflows that save time and increase efficiency.',
      features: ['Process optimization', 'Efficiency analysis', 'Implementation roadmap', 'Performance metrics']
    },
    {
      icon: 'ri-robot-line',
      title: 'Office Automation',
      description: 'Advanced automation solutions that handle repetitive tasks, freeing your team for higher-value work.',
      features: ['Task automation', 'Data processing', 'Report generation', 'Smart scheduling']
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-navy/10 rounded-md">
            <span className="text-navy text-base font-semibold">Who We Serve</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-navy">
            Local Teams Ready for <span className="text-gold">Practical Improvement</span>
          </h2>
          <p className="text-lg text-charcoal max-w-3xl mx-auto">
            We work with office-based teams across Northwest Georgia who want practical improvement, not disruption.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl border border-soft-gray/30 shadow-sm hover:shadow-xl transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-xl mb-6">
              <i className="ri-building-line text-3xl text-navy"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-navy">Small & Mid-Sized Businesses</h3>
            <p className="text-charcoal leading-relaxed">
              Local businesses looking to improve efficiency and stay competitive with practical AI solutions.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-soft-gray/30 shadow-sm hover:shadow-xl transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-xl mb-6">
              <i className="ri-hammer-line text-3xl text-navy"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-navy">Construction & Field Service</h3>
            <p className="text-charcoal leading-relaxed">
              Office staff managing scheduling, documentation, and customer communication for field operations.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-soft-gray/30 shadow-sm hover:shadow-xl transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-xl mb-6">
              <i className="ri-customer-service-2-line text-3xl text-navy"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-navy">Customer Service Teams</h3>
            <p className="text-charcoal leading-relaxed">
              Administrative teams handling customer inquiries, support tickets, and daily communications.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-soft-gray/30 shadow-sm hover:shadow-xl transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-xl mb-6">
              <i className="ri-home-smile-line text-3xl text-navy"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-navy">Real Estate Offices</h3>
            <p className="text-charcoal leading-relaxed">
              Front office staff, agents,  and admin teams managing listings, property descriptions and paperwork.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-soft-gray/30 shadow-sm hover:shadow-xl transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-xl mb-6">
              <i className="ri-user-star-line text-3xl text-navy"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-navy">Owners & Managers</h3>
            <p className="text-charcoal leading-relaxed">
              Leaders responsible for operations who want to improve team productivity and efficiency.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-soft-gray/30 shadow-sm hover:shadow-xl transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-xl mb-6">
              <i className="ri-community-line text-3xl text-navy"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-navy">Churches & Nonprofits</h3>
            <p className="text-charcoal leading-relaxed">
              Office teams managing communications, events, and administrative tasks for their communities.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-soft-gray/30 shadow-sm hover:shadow-xl transition-all">
            <div className="w-16 h-16 flex items-center justify-center bg-navy/10 rounded-xl mb-6">
              <i className="ri-user-line text-3xl text-navy"></i>
            </div>
            <h3 className="text-xl font-bold mb-3 text-navy">Individuals</h3>
            <p className="text-charcoal leading-relaxed">
              We offer an AI Acceleration Course to professionals who want a personalized roadmap&nbsp;
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
